import { MediaFileCategory } from '@/features/media-file/domain/models/media-file.ts'

export const getMediaFileCategoryColor = (
  category: MediaFileCategory | undefined
): string => {
  let colorName = 'gray'
  if (category) {
    const colorNames: Record<MediaFileCategory, string> = {
      [MediaFileCategory.Music]: 'green',
      [MediaFileCategory.Advert]: 'orange',
      [MediaFileCategory.Voice]: 'blue',
      [MediaFileCategory.SoundEffect]: 'purple',
      [MediaFileCategory.Media]: 'gray',
    }
    colorName = colorNames[category] ?? 'gray'
  }
  return `bg-${colorName}-300 text-${colorName}-800`
}
